import { register } from "./register";
import { CODES, KEYS } from "../utils/keys";
import { abacusIcon } from "../components/board/icons";
import { StoreAction } from "../utils/store";

export const actionToggleStats = register({
  name: "stats",
  label: "stats.title",
  icon: abacusIcon,
  paletteName: "Toggle stats",
  viewMode: true,
  trackEvent: { category: "menu" },
  keywords: ["edit", "attributes", "customize"],
  perform(elements, appState) {
    return {
      appState: {
        ...appState,
        stats: { ...appState.stats, open: !this.checked!(appState) },
      },
      storeAction: StoreAction.NONE,
    };
  },
  checked: (appState) => appState.stats.open,
  keyTest: (event) =>
    !event[KEYS.CTRL_OR_CMD] && event.altKey && event.code === CODES.SLASH,
});
